/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendActualProductDto } from '../../models/backend-actual-product-dto';
import { BackendPatchedActualProductRequestDto } from '../../models/backend-patched-actual-product-request-dto';

export interface MonitoringActualsProductsPartialUpdate$FormData$Params {
  id: number;
  body?: BackendPatchedActualProductRequestDto;
}

export function monitoringActualsProductsPartialUpdate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringActualsProductsPartialUpdate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendActualProductDto>> {
  const rb = new RequestBuilder(rootUrl, monitoringActualsProductsPartialUpdate$FormData.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendActualProductDto>;
    }),
  );
}

monitoringActualsProductsPartialUpdate$FormData.PATH = '/api/monitoring/actuals/products/{id}/';
